import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserDTO } from '../dto/responses/UserDTO';
import { USER_KEY } from '../shared/constants';
import { StorageService } from '../shared/services/storage/storage.service';

@Injectable({
    providedIn: 'root'
})
export class ProfileCompleted {
    private storageService = inject(StorageService);
    constructor(private router: Router) {}

    async canActivate(): Promise<boolean> {
        const user: UserDTO | null = await this.storageService.get(USER_KEY);
        if (!user) {
            this.router.navigate(['/login']);
            return false;
        }

        if (user.isProfileCompleted === false) {
            this.router.navigate(['/register']);
            return false;
        }

        return true;
    }
}
